<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-list-item
    :class="active?'activeListItem':''"
    :style="subBtn ? 'width: 90% !important' : ''"
    class="rounded overflow-hidden px-4 mt-0 mb-2 ml-auto mr-0"
    color="white"
    @click="$emit('click')"
  >
    <v-list-item-title
      style="font-size: 12px !important;"
    >
      {{ $t(title) }}
    </v-list-item-title>
    <v-list-item-action v-if="loading">
      <v-progress-circular
        indeterminate
        size="16"
      />
    </v-list-item-action>
    <v-list-item-action v-else-if="locked">
      <v-icon
        color="#ffffff"
        size="18"
      >
        mdi-lock
      </v-icon>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'NavigationListItem',
  props: {
    noPower: {},
    title: {},
    locked: {},
    loading: {},
    active: {},
    subBtn: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.activeListItem {
  color: #f1f1f1 !important;
  background: #3E3E3EFF;
  text-shadow: 0 0 1px #fff;
}
</style>
